import {
    put
} from 'redux-saga/effects';
import * as types from 'constants/actionTypes';
import sagaUtil from './sagaUtil';
import env from 'config/env';

const auditSagaUtil = {
    fetch: function* (url, data, success, failed) {
        yield put({
            type: types.SNACKBAR_SHOW_MESSAGE,
            message: "Audit Update In Progress"
        });

        yield put({
            type: 'AUDIT-LOADING',
            val: 1
        });

        let promise;

        try {
            promise = yield (data ? sagaUtil.post(env.baseUrl() + url, data) : sagaUtil.get(env.baseUrl() + url))
                .then(resp => {
                    return resp.json()
                });
            if (promise && promise.success) {
                yield put(success(promise));

                yield put({
                    type: types.SNACKBAR_SHOW_MESSAGE,
                    message: "Audit Update Success"
                });
            } else {
                if (failed) {
                    yield put(failed(promise));
                }
                else {
                    yield put({
                        type: 'ERROR',
                        message: promise && promise.error
                    });

                }
                if (promise.statusCode) {
                    switch (promise.statusCode) {
                        case 401:
                            yield put({
                                type: types.UNAUTHORIZED_USER
                            });
                            break;
                        default:
                            break;
                    }
                }
            }
        } catch (e) {
            yield put({
                type: 'API_EXCEPTION',
                e
            });
            if (failed)
                yield put(failed(promise));
        } finally {
            yield put({
                type: 'AUDIT-LOADING',
                val: -1
            });
        }
    }
};

export default auditSagaUtil;